module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9r1r3r6r-e47262760083a21432c36fc1f3e22c24.svg";